import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — deep-link payment-request page (`/payment-request?payment_id=&
 *              amount=`): passes params through as the model and kicks the controller's
 *              init task (which authenticates from the token and loads the payment).
 *   extends:   Route (@ember/routing/route)
 *   template:  none
 *   model:     params (raw query-param object: payment_id, amount)
 *   key:       setupController, resetController
 *   uses:      session (@service, not directly called here — see controller for auth)
 *   siblings:  controllers/payment-request.js (owns initPageTask this route starts/cancels)
 *   tests:     simple-routes-test.js ("payment-request route starts initPageTask and
 *              cancels it on leave", "payment-request route model returns the deep-link
 *              params verbatim")
 *   gotchas:   -
 *
 * Deep-link entry route for the standalone payment-completion page.
 */
export default class PaymentRequestRoute extends Route {
  @service session;

  breadCrumb = {
    title: 'Richiesta pagamento',
  };

  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.initPageTask.perform();
  }

  resetController(controller) {
    controller.initPageTask.cancelAll();
    // the outcome poll (controllers/payment-request.js pollPaymentTask) stops with the page
    controller.pollPaymentTask.cancelAll();
    controller.verifyTimedOut = false;
  }
}
